module.exports = __webpack_public_path__ + "img/sv28on.797a969e.svg";